module.exports = __webpack_public_path__ + "img/esteto-black2.a35952b1.jpg";